import { useMemo } from 'react';
import { Form } from 'antd';

import { FormCheckbox, FormSelect } from 'components';

import { useGetRequest } from 'hooks';
import { mapRetailersToSort } from 'utils';

import { RetailersResponse } from 'codegen';

const {
  useWatch,
  useFormInstance,
} = Form;

export const RetailersSelect = () => {
  const form = useFormInstance();

  const regions = useWatch(['genericValues', 'regions'], form);
  const isExclusiveForRetailer = useWatch(['retailersValue', 'isExclusiveForRetailer'], form);

  const { data } = useGetRequest<RetailersResponse>({
    url: '/merchants',
    queryParams: { regions },
    options: {
      refreshDeps: [regions],
      debounceWait: 1000,
    },
  });

  const retailers = useMemo(() => mapRetailersToSort(data?.merchants), [data?.merchants]);

  return (
    <>
      <FormCheckbox
        label='Exclusive Offer'
        name={['retailersValue', 'isExclusiveForRetailer']}
        onCheckboxChange={() => form.setFieldValue(['retailersValue', 'displayRetailers'], undefined)}
      />

      <FormSelect
        mode={isExclusiveForRetailer ? undefined : 'multiple'}
        label='Retailers In App'
        name={['retailersValue', 'displayRetailers']}
        tooltip={isExclusiveForRetailer ? undefined : 'Order will be saved'}
        options={retailers}
        placeholder='Will be displayed in the app'
        className='listByOrder'
        rules={[{
          message: 'Retailer is required!',
          required: true,
        }]}
      />
    </>
  );
};
